import '../scss/styles.scss';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

/* global dataLayer */

function observe(img) {
	const observer = new IntersectionObserver((entries, imgObserver) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				img.classList.remove('lazyload');
				imgObserver.unobserve(entry.target);
			}
		});
	});
	observer.observe(img);
}

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('img[loading="lazy"]').forEach((img) => {
		if (img.complete) {
			observe(img);
		} else {
			img.onload = function () {
				observe(img);
			};
		}
	});

	new Swiper('.time-to-glow-products__swiper', {
		modules: [Navigation, Pagination],
		init: true,
		slidesPerView: 1,
		spaceBetween: 0,
		watchOverflow: true,
		observer: true,
		observeParents: true,
		pagination: {
			el: '.time-to-glow-products__pagination',
			type: 'bullets',
			clickable: true,
		},
		navigation: {
			prevEl: '.time-to-glow-products__arrow--prev',
			nextEl: '.time-to-glow-products__arrow--next',
		},
		breakpoints: {
			1000: {
				slidesPerView: 2,
				spaceBetween: 30,
			}
		}
	});

	const questions = () => {
		const element = document.querySelector('.time-to-glow-test__slider');
		const questionsElement = element.querySelector('.time-to-glow-questions');
		const resultsElement = element.querySelector('.time-to-glow-results');
		const questions = questionsElement.querySelectorAll('.time-to-glow-question');
		const answers = [];
		const sliderSettings = {
			slidesPerView: 1,
			spaceBetween: 0,
			allowTouchMove: false,
		};

		const slider = new Swiper(element, sliderSettings);
		const questionsSlider = new Swiper(questionsElement, sliderSettings);
		const resultsSlider = new Swiper(resultsElement, sliderSettings);

		const shema = [
			['yes', 'any', 'any', 'any'],
			['no', 'yes', 'any', 'any'],
			['no', 'no', 'yes', 'any'],
			['no', 'no', 'no', 'any']
		];

		const checkResult = (element) => {
			for (let index = 0; index < answers.length; index++) {
				if (element[index] != answers[index] && element[index] != 'any') return false;
			}
			return true;
		};

		const setResult = () => {
			let result = 0;
			shema.forEach((element, index) => {
				if(checkResult(element)) result = index;
			});

			resultsSlider.slideTo(result, 0);
			slider.slideNext();
		};

		const setDataLayer = (index) => {
			let event = '';
			switch(index) {
				case 1:
					event = 'first_step';
					break;
				case 2:
					event = 'second_step';
					break;
				case 3:
					event = 'third_step';
					break;
				case 4:
					event = 'fourth_step';
					break;
			}
			dataLayer.push({event});
		};
		
		const buttons = questionsElement.querySelectorAll('.time-to-glow-question__button');
		buttons.forEach((button) => {
			button.addEventListener('click', () => {
				let index = questionsSlider.activeIndex + 1;
				setDataLayer(index);
				answers.push(button.dataset.answer);
				if (index === questions.length) setResult();
				else questionsSlider.slideNext();
			});
		});
	};

	questions();
});